// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#changelocation[data-v-554e686c]{display:flex;flex-direction:column;align-items:flex-start!important}#changelocation span#zipCodeError[data-v-554e686c]{color:#d93551}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
